<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
  >
    <path
      d="M2.22,70a6.67,6.67,0,0,0,6.67,6.67H20.65c.66-5.63,5.16-10,10.6-10h37.5c5.44,0,9.94,4.37,10.6,10H91.11A6.67,6.67,0,0,0,97.78,70L100,61.11a6.67,6.67,0,0,0-6.67-6.66H10.48A20.25,20.25,0,0,1,14,36.58a8,8,0,0,0,2.57,1,7.78,7.78,0,1,0-6.11-9.15A7.7,7.7,0,0,0,11,33.21,24.66,24.66,0,0,0,5.91,54.49,6.67,6.67,0,0,0,0,61.11Z"
    />
    <path
      d="M21.64,50H78.36a19.05,19.05,0,0,0-16.8-14.64c-.07,3.47-11.56,12-11.56,12s-11.49-8.58-11.57-12A19.05,19.05,0,0,0,21.64,50Z"
    />
    <path
      d="M50,37.85c8.77,0,15.89-13.19,15.89-22a15.89,15.89,0,0,0-31.78,0C34.11,24.66,41.23,37.85,50,37.85Z"
    />
    <path
      d="M73.66,99.5,75,78.09c0-3.85-2.8-7-6.25-7H31.25c-3.45,0-6.25,3.13-6.25,7L26.34,99.5Z"
    />
  </svg>



</template>


<script>
export default {
  name: 'icon-speaker-podium',
  // props: {
  //   fill: {
  //     type: String,
  //     required: false,
  //     default: '#000',
  //   }
  // },
  // components: {},
  // data () {
  //   return {}
  // },
  // methods: {},
  // computed: {},
}
</script>


<style scoped lang="sass">
// @import index

</style>



// WEBPACK FOOTER //
// src/components/icons/icon-speaker-podium.vue